module.exports = __webpack_public_path__ + "assets/1-Austin-Tech-Sales-Career.3573c9ef.png";